import type { FTFindEvents, FTNavEvents, HistoryEvent, SAN_HEADER, SquirrelEvents, TrackingEvents } from "./tracking";
import { CLASSNAME, SELECTOR } from "./helper";

export class Searchbar {
  isInitialized = false;
  searchField: HTMLInputElement;
  searchbarAbort: HTMLSpanElement;
  searchIcon: HTMLDivElement;
  searchCurtain: HTMLDivElement;
  header: HTMLElement;

  constructor() {
    this.searchField = document.querySelector(SELECTOR.SEARCH_FIELD) as HTMLInputElement;
    this.searchIcon = document.querySelector(SELECTOR.SEARCH_ICON) as HTMLDivElement;
    this.header = document.querySelector(SELECTOR.HEADER_ELEMENT) as HTMLElement;
    this.searchbarAbort = document.querySelector(SELECTOR.ABORT_BUTTON) as HTMLSpanElement;
    this.searchCurtain = document.querySelector(SELECTOR.CURTAIN) as HTMLDivElement;

    if (this.searchIcon && this.header) {
      this.searchIcon.addEventListener("click", this.toggleSearchField.bind(this));
    }

    if (this.searchField) {
      this.searchField.removeAttribute("disabled");
      this.searchField.addEventListener("focus", (event: FocusEvent) => {
        if (event.isTrusted && !this.header.classList.contains(CLASSNAME.SEARCHBAR_HEADER_ACTIVE)) {
          window.o_global.events<SquirrelEvents>().emit("squirrel.search.open");
        }
      });
    }

    if (this.searchbarAbort) {
      this.searchbarAbort.addEventListener("click", () => {
        window.o_global.events<SquirrelEvents>().emit("squirrel.search.close");
      });
    }

    if (this.searchCurtain) {
      this.searchCurtain.addEventListener("click", () => {
        window.o_global.events<SquirrelEvents>().emit("squirrel.search.close");
      });
    }

    if (this.header) {
      window.o_global.events<FTNavEvents>().on("ftnav.global-navigation.opened", () => this.showSearchField.bind(this));
      window.o_global.events<SquirrelEvents>().on("squirrel.search.open", (event: HistoryEvent) => {
        this.openSearch();
        this.registerHistoryEvents(event);
      });
      window.o_global.events<SquirrelEvents>().on("squirrel.search.close", (event: HistoryEvent) => {
        this.closeSearch();
        this.removeHistoryEvents(event);
      });
      window.o_global.events<SquirrelEvents>().on("squirrel.search.hide", () => this.hideSearchField.bind(this));
    }

    this.isInitialized = true;
  }

  hideSearchField() {
    this.header.classList.remove(CLASSNAME.SEARCHBAR_HEADER_VISIBILITY);
  }

  showSearchField() {
    this.header.classList.add(CLASSNAME.SEARCHBAR_HEADER_VISIBILITY);
  }

  private toggleSearchField() {
    const isVisible: boolean = this.header.classList.contains(CLASSNAME.SEARCHBAR_HEADER_VISIBILITY) || false;
    const san_Header: SAN_HEADER = isVisible ? "search_close" : "search_open";

    this.header.classList.toggle(CLASSNAME.SEARCHBAR_HEADER_VISIBILITY);

    if (!isVisible) {
      this.searchField.focus();
      window.o_global.events<FTNavEvents>().emit("ftnav.global-navigation.close");
    }

    window.o_global.events<TrackingEvents>().emit("tracking.bct.submitEvent", { san_Header });
  }

  private toggleSearchBox(enable: boolean) {
    if (this.header) {
      this.header.classList.toggle(CLASSNAME.SEARCHBAR_HEADER_ACTIVE, enable);
    }
  }

  private openSearch() {
    this.toggleSearchBox(true);
  }

  private closeSearch() {
    this.toggleSearchBox(false);
    this.searchField.blur();

    window.o_global.events<TrackingEvents>().emit("tracking.bct.submitEvent", {
      san_Header: "search_cancel",
    });
  }

  private registerHistoryEvents(event: HistoryEvent) {
    if (event && event.historic) {
      return;
    }

    window.o_global.events<FTFindEvents>().emit("ftfind.history.merge", {
      topic: "squirrel.search.close",
      data: { historic: true },
    });

    // TODO: How to merge ftfind.history into squirrel?
    window.o_global.events<FTFindEvents>().emit("ftfind.history.push", {
      topic: "squirrel.search.open",
      data: { historic: true },
    });
  }

  private removeHistoryEvents(event: HistoryEvent) {
    if (event && event.historic) {
      return;
    }

    window.o_global.events<FTFindEvents>().emit("ftfind.history.shift");
  }
}

export const searchbar = () => {
  const searchbar = new Searchbar();
  return {
    init: () => searchbar,
    hideSearchField: searchbar.hideSearchField,
    showSearchField: searchbar.showSearchField,
  };
};
